// extracted by mini-css-extract-plugin
export var stylesNavLink = "styles-module--stylesNavLink--7gJ9H";
export var textInner = "styles-module--textInner--BK8PX";